import React from 'react';

const AdoptPage = () => {
  const loadRazorpay = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePayment = async () => {
    const res = await loadRazorpay('https://checkout.razorpay.com/v1/checkout.js');

    if (!res) {
      alert('Razorpay SDK failed to load. Are you online?');
      return;
    }

    const options = {
      key: 'rzp_test_YourKeyHere', // Replace with your Razorpay Test Key
      amount: 500000, // amount in paise = ₹5000
      currency: 'INR',
      name: 'Adopt-A-Pet',
      description: 'Adoption Payment',
      image: 'https://yourlogo.url', // optional logo URL
      handler: function (response) {
        alert('Payment successful! Payment ID: ' + response.razorpay_payment_id);
      },
      prefill: {
        name: 'Chandrashekher Prasad',
        email: 'youremail@example.com',
        contact: '9999999999',
      },
      notes: {
        address: 'Adoption Center',
      },
      theme: {
        color: '#3399cc',
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <h1 className="text-3xl font-bold mb-4">Adopt Your Pet</h1>
      <p className="mb-6 text-lg">Click below to pay ₹5000 for adoption</p>
      <button
        onClick={handlePayment}
        className="px-6 py-3 bg-green-600 text-white rounded-md font-semibold hover:bg-green-500 transition"
      >
        Pay ₹5000
      </button>
    </div>
  );
};

export default AdoptPage;
